import React from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import AddBlogs from "./AddBlogs";
import UpdateBlogs from "./UpdateBlogs";
import DeleteBlogs from "./DeleteBlogs";
import Errors from "../errors";
import Spinner from "../../components/spinner";
import { Alert, Snackbar } from "@mui/material";
import Pagination from "../../components/elements/pagination";
import useBlogsList from "../../hooks/blog/useBlogsList";
import SwitchToggle from "../../components/elements/switchtoggle/SwitchToggle";
import Loader from "../../components/loader";

function Blogs() {
  const {
    data,
    paramsObject,
    blogId,
    openAddModal,
    isOpenEditModal,
    openDeleteModal,
    isDeletedSuccess,
    blogStatus,
    handleBlogStatusChange,
    handleSearchVal,
    handleOpenAddModal,
    handleModalClose,
    handleOpenEditModal,
    handleOpenDeleteModal,
    handleDeleteSuccess,
    handleCloseDeleteSuccessAlert,
    handlePageClick,
    isToggleLoading,
  } = useBlogsList();

  return (
    <>
      <div className="blogs px-4">
        <div className="blog__head headingBorder__b">
          <h2 className="titleHeading">Blogs</h2>
        </div>
        <div className="blog_table py-5 space-y-5">
          <div className="flex items-center mb-4">
            <div className="flex items-center">
              <SwitchToggle
                label="Enable Blogs"
                name="blogStatus"
                checkedValue={blogStatus}
                onChange={handleBlogStatusChange}
                className="mr-2"
              />
              {isToggleLoading && <Loader className="text-blue-500 h-4 w-4 ml-2" />}
            </div>
          </div>
          <div className="flex items-center space-x-4">
            <div className="flex-1">
              <input
                onChange={handleSearchVal}
                value={paramsObject?.search_query || ""}
                type="text"
                name="search_query"
                placeholder="Search Blogs...."
                className="input"
              />
            </div>
            <div onClick={handleOpenAddModal}>
              <Button
                variant="outlined"
                startIcon={<AddIcon />}
                className="primaryBtn-outlined"
              >
                Create Blog
              </Button>
            </div>
          </div>
          
          {data?.isLoading ? (
            <Spinner />
          ) : data?.status === "error" ? (
            <Errors errorObject={data.error} inline />
          ) : (
            <>
              <div className="overflow-x-auto bg-white rounded-lg shadow overflow-y-auto relative">
                <table className="border-collapse table-auto w-full whitespace-no-wrap bg-white table-striped relative">
                  <thead>
                    <tr className="text-left">
                      <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs">
                        Sr.no
                      </th>
                      <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs text-center">
                        Blog Title
                      </th>
                      <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs text-center">
                        Published On
                      </th>
                      <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs text-center">
                        Status
                      </th>
                      <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs text-center">
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.data?.data?.map((item, idx) => {
                      const { title, blog_id, status, published_at } = item;
                      return (
                        <tr key={idx}>
                          <td className="border-dashed border-t border-gray-200 userId">
                            <span className="text-gray-700 px-6 py-3 flex items-center text-sm">
                              {paramsObject.limit * +paramsObject.page_number + idx + 1}
                            </span>
                          </td>
                          <td className="border-dashed border-t border-gray-200 firstName">
                            <span className="text-gray-700 px-6 py-3 text-center block text-sm">
                              {title}
                            </span>
                          </td>
                          <td className="border-dashed border-t border-gray-200 firstName">
                            <span className="text-gray-700 px-6 py-3 text-center block text-sm">
                              {published_at ? published_at.split(' ')[0] : "---"}
                            </span>
                          </td>
                          <td className="border-dashed border-t border-gray-200 emailAddress">
                            <div className="flex items-center justify-center">
                              {status === "1" ? (
                                <span className="px-4 py-1 font-semibold rounded bg-green-700 text-green-200">
                                  Active
                                </span>
                              ) : (
                                <span className="px-4 py-1 font-semibold rounded bg-red-700 text-red-200">
                                  Disabled
                                </span>
                              )}
                            </div>
                          </td>
                          <td className="border-dashed border-t border-gray-200 phoneNumber">
                            <div className="flex items-center space-x-5 justify-center">
                              <div>
                                <IconButton
                                  onClick={() => handleOpenEditModal(blog_id)}
                                >
                                  <EditIcon />
                                </IconButton>
                              </div>
                              <div onClick={() => handleOpenDeleteModal(blog_id)}>
                                <IconButton>
                                  <DeleteIcon />
                                </IconButton>
                              </div>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              <div className="my-7">
                <Pagination
                  currentPage={+paramsObject.page_number}
                  lengthofItems={data?.data?.total_count}
                  limit={paramsObject.limit}
                  onPageChange={handlePageClick}
                />
              </div>
            </>
          )}
        </div>
      </div>

      {openAddModal && (
        <AddBlogs open={openAddModal} handleClose={handleModalClose} />
      )}
      {isOpenEditModal && (
        <UpdateBlogs
          blog_id={blogId}
          open={isOpenEditModal}
          handleClose={handleModalClose}
        />
      )}
      <DeleteBlogs 
        url={'delete-blog'} 
        queryKey={'get-blog-list'} 
        open={openDeleteModal} 
        onClose={handleModalClose} 
        blog_id={blogId} 
        onDelete={handleDeleteSuccess} 
      />
      <Snackbar
        open={isDeletedSuccess}
        autoHideDuration={6000}
        onClose={handleCloseDeleteSuccessAlert}
      >
        <Alert
          onClose={handleCloseDeleteSuccessAlert}
          severity="success"
          sx={{ width: "100%" }}
        >
          Blog Deleted Successfully
        </Alert>
      </Snackbar>
    </>
  );
}

export default Blogs;
